import React, { useContext } from 'react'
import { Router, Route, Switch } from 'react-router-dom'
import AppCtx from 'contexts/App'
import s from './App.module.scss'

// Components
import SiteHeader from 'components/site/SiteHeader/SiteHeader'
import Introduction from 'components/site/Introduction/Introduction'
import ErrorBoundary from 'components/containers/ErrorBoundary/ErrorBoundary'

//
export default function App({ history, routes }) {
	const { content } = useContext(AppCtx)

	return (
		<div className={s.root}>
			<a href="#main-content" className="visually-hidden">
				{content.general.skipToMainContent}
			</a>
			<main id="main-content">
				<Router history={history}>
					<ErrorBoundary history={history}>
						<div data-restrain="max">
							<SiteHeader />
						</div>
						<div data-restrain="m" data-space="m">
							<Introduction />
						</div>
						<ErrorBoundary history={history}>
							<Switch>
								{routes.map(({ path, exact, Component }) => {
									return <Route key={path || ''} path={path} exact={exact} component={Component} />
								})}
							</Switch>
						</ErrorBoundary>
					</ErrorBoundary>
				</Router>
			</main>
		</div>
	)
}
